import React, { useRef } from 'react';

import { useListStyles } from './style';

type ListProps = {
    children: React.ReactNode,
    containerHeight?: number | string,
    style?: React.CSSProperties,
    containerRef?: React.RefObject<HTMLDivElement>,
};

List.defaultProps = {
    containerHeight: '',
    style: {},
    containerRef: null,
};

function List(props: ListProps): React.ReactElement {
    const { children, containerHeight, style, containerRef } = props;
    const classes = useListStyles();

    return (
        <div ref={containerRef} className={classes.list} style={{ height: containerHeight, ...style }}>
            {children}
        </div>
    );
}

export { List };
